<template>
  <el-dialog title="公示模板编辑" class="MeterFeeTagEditor" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" width="1200px" @close="closeWindow">
    <el-row>
      <el-col :span="10">
        <el-descriptions class="margin-top" title="" :column="1" size="mini" border :labelStyle="{width: '100px'}">
          <el-descriptions-item label="公示模板名称">
            <el-input style="width: 100%;" size="mini" placeholder="公示模板名称" v-model="from_data.name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <el-select size="mini" style="width: 100%" v-model="from_data.meter_types" multiple clearable filterable placeholder="仪表类型" class="kuan" @change="getOrderMeter">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="分摊楼栋" v-if="!from_data.son_meter_ids">
            <div style="display: flex;flex-direction: row">
              <SelectProjectTreeComponent width="280px" :project_id="mainObj.project_id" :checked_keys="from_data.house_ids"/>
              <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
                <template #reference>
                  <el-button>添加分摊楼栋</el-button>
                </template>
                <template #default>
                  <ProjectTree :project_id="mainObj.project_id" :checked_keys="from_data.house_ids" :is-checkbox="true" @onNode="onNodeProject"/>
                </template>
              </el-popover>
            </div>
            <!--        <div style="color: #ff3d00;margin-left: 20px;">选择了下级仪表就不能选择添加收费用户，下级仪表与收费用户二选其一。</div>-->
          </el-descriptions-item>
          <el-descriptions-item label="能耗类型">
            <el-checkbox-group size="mini" v-model="from_data.meter_energys" @change="getOrderMeter">
              <el-checkbox :label="2">物业能耗</el-checkbox>
              <el-checkbox :label="3">分摊能耗</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="仪表">
            <el-select style="width: 100%;" v-model="from_data.meter_ids" multiple filterable collapse-tags clearable placeholder="请选择">
              <el-option
                v-for="item in meter_list"
                :key="item.id"
                :label="item.meter_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="每页显示条数">
            <el-input style="width: 100%;" size="mini" type="number" placeholder="输入数字" v-model="from_data.page_limit" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="系数精确位数">
            <el-input style="width: 100%;" size="mini" type="number" placeholder="输入数字" v-model="from_data.coefficient_precision"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="系数单位">
            <el-select style="width: 100%;" v-model="from_data.coefficient_unit" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in coefficient_unit_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="前台电话">
            <el-input style="width: 100%;" size="mini" placeholder="输入前台电话" v-model="from_data.front_phone"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="落款单位">
            <el-input size="mini" placeholder="输入落款单位" v-model="from_data.signature_unit"></el-input>
            <div style="color: #ff3d00;margin-left: 20px;">落款单位是公示模板的公示单位，默认为项目单位，如：xxxx物业管理处。</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
      <el-col :span="14">
        <MeterOrderPublicityTemplate :publicity="from_data" />
      </el-col>
    </el-row>

    <div class="dialog-footer">
      <el-button size="mini" @click="dialogVisible=false">取消</el-button>
      <el-button size="mini" type="primary" @click="submitForm()">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SelectProjectTreeComponent from "../../meter/components/SelectProjectTreeComponent";
import ProjectTree from "../../meter/components/ProjectTree";
import MeterHttp from "../../../common/MeterHttp";
import MeterOrderPublicityTemplate from "./MeterOrderPublicityTemplate";
export default {
  name: "MeterOrderPublicityEditor",
  inject:['mainObj','componentId','setComponentId'],
  components: {
    MeterOrderPublicityTemplate,
    ProjectTree, SelectProjectTreeComponent},
  data(){
    return{
      project_id:0,
      from_data:{
        name:"",
        project_id:0,
        meter_types:[],
        meter_ids:[],
        meter_energys:[3],
        house_ids:"",
        page_limit:10,
        coefficient_unit:1,
        coefficient_precision:2,
        front_phone:"",
        signature_unit:"",
        status:1,
      },
      dialogVisible:false,
      callback:null,
      meter_list:[],
      meter_type_list:[],
      coefficient_unit_list:[
        {id:1,name:"元/户"},
        {id:2,name:"元/平方米"},
        {id:3,name:"元/立方米"},
        {id:4,name:"元/吨"},
        {id:5,name:"元/度"},
        {id:6,name:"元/楼层"},
      ],
    }
  },
  methods:{
    show({project_id=0,id=0},callback){
      const that=this;
      that.project_id=project_id;
      that.getMeterTypeList();
      if(id){
        that.getData(id);
      }else {
        that.initData();
      }
      // that.getParentSon("",data=>that.meter_list=data)
      that.dialogVisible=true;
      that.callback=callback;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getData(id=0){
      const that = this;
      let where={};
      MeterHttp.get("MeterOrderPublicity/getData",{
        id:id,
      },ret=>{
        console.log(ret);
        if(ret.code){
          ret.data.meter_ids=ret.data.meter_ids.split(',').map(re=>re*1);
          ret.data.meter_types=ret.data.meter_types.split(',').map(re=>re*1);
          ret.data.meter_energys=(ret.data.meter_energys||'').split(',').map(re=>re*1);
          that.from_data=ret.data;

          that.getOrderMeter()
        }
      })
    },
    initData(){
      this.from_data.id="";
      this.from_data.name="";
      this.from_data.project_id=this.project_id;
      this.from_data.meter_types=[];
      this.from_data.meter_ids=[];
      this.from_data.meter_energys=[3];
      this.from_data.house_ids="";
      this.from_data.page_limit=10;
      this.from_data.coefficient_unit=1;
      this.from_data.coefficient_precision=2;
      this.from_data.front_phone="";
      this.from_data.signature_unit="";
      this.from_data.status=1;
    },
    getParentSon(ids,callback){
      MeterHttp.get("Meter/getMeterAllKeyValue?user_type="+(that.$route.query.type||0),{
        ids:ids,
        project_id:this.project_id,
      },ret=>{
        if(ret.code){
          callback(ret.data);
        }else {
          callback([])
        }
      })
    },
    getOrderMeter(){
      const that=this;
      MeterHttp.get("MeterOrder/getOrderMeter",{
        project_id:that.project_id,
        meter_types:that.from_data.meter_types.join(','),
        meter_energys:that.from_data.meter_energys.join(','),
        house_ids:that.from_data.house_ids,
      },ret=>{
        if(ret.code){
          that.meter_list=ret.data;
          that.from_data.meter_ids=ret.data.map(res=>res.id)
        }
      })
    },
    submitForm(){
      const that = this;
      let from_data=ERP.reJson(that.from_data);
      from_data.meter_ids=from_data.meter_ids.join(',');
      from_data.meter_types=from_data.meter_types.join(',');
      from_data.meter_energys=from_data.meter_energys.join(',');
      MeterHttp.post("MeterOrderPublicity/setData",{
        ...from_data
      },ret=>{
        if(ret.code){
          that.from_data.id=ret.data.id;
          that.$message.success(ret.msg||'保存成功')
          typeof that.callback==='function'&&that.callback();
        }else {
          that.$message.error(ret.msg||'保存失败')
        }
      });
    },
    closeWindow(){
      this.callback=undefined;
    },
    onNodeProject(data){
      let house_ids=data.map(ret=>ret.house_id);
      this.from_data.house_ids=house_ids.join(',')
      this.getOrderMeter()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.MeterFeeTagEditor{
  /deep/.el-dialog{
    //.el-dialog__wrapper{
    //   max-width: 1200px;
    //}
    .el-dialog__body{
      padding-top: 5px;
    }
  }
}
.dialog-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderPublicityEditor.vue